import { render } from "./SpiritOfJapan3.vue?vue&type=template&id=4dde7b1e&scoped=true"
import script from "./SpiritOfJapan3.vue?vue&type=script&lang=js"
export * from "./SpiritOfJapan3.vue?vue&type=script&lang=js"

import "./SpiritOfJapan3.scss?vue&type=style&index=0&id=4dde7b1e&lang=scss&scoped=true&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4dde7b1e"]])

export default __exports__